import React, { createContext, useContext } from "react";

export const DropdownMenuContentPropsContext = React.createContext<{
  onSelect?: (event: Event) => void;
}>({});

export const getDropdownMenuItemClassName = (
  className = "",
  selected = false,
  hovered = false,
) => {
  return `dropdown-menu-item dropdown-menu-item-base ${className}
  ${selected ? "dropdown-menu-item--selected" : ""} ${hovered ? "dropdown-menu-item--hovered" : ""}`.trim();
};

export const useHandleDropdownMenuItemClick = (
  origOnClick?: (event: React.MouseEvent) => void,
  onSelect?: (event: Event) => void,
) => {
  const DropdownMenuContentProps = useContext(DropdownMenuContentPropsContext);

  return (event: React.MouseEvent) => {
    origOnClick?.(event);
    const itemSelectEvent = new Event("select", { bubbles: true });
    (itemSelectEvent as any).preventClose = event?.preventDefault;
    DropdownMenuContentProps.onSelect?.(itemSelectEvent);
  };
};
